module.exports = __webpack_public_path__ + "static/media/photo170.ae2b2a51.jpg";